import React, { useState } from 'react';

const ProductWishlist = ({ product }) => {
    // State to track whether the product is in the wishlist
    const [isInWishlist, setIsInWishlist] = useState(false);

    // Toggle wishlist state
    const handleWishlistToggle = () => {
        if (isInWishlist) {
            // Remove from wishlist
            removeFromWishlist(product.id);
        } else {
            // Add to wishlist
            addToWishlist(product.id);
        }
        setIsInWishlist(!isInWishlist); // Toggle the state
    };

    // Mock functions for adding/removing from wishlist
    const addToWishlist = (productId) => {
        console.log(`Added product ${productId} to wishlist`);
        // Logic to add product to wishlist
    };

    const removeFromWishlist = (productId) => {
        console.log(`Removed product ${productId} from wishlist`);
        // Logic to remove product from wishlist
    };

    return (
        <>
            <div className="product-tile__wishlist absolute top-0 right-0 p-[17px]" onClick={handleWishlistToggle}>
                {isInWishlist ? (
                    <span className="icon-heart text-mb-red">
                        <i className={'icon icon-heart'} onClick={handleWishlistToggle}></i>
                    </span>
                ) : (
                    <span className="icon-heart">
                        <i className={'icon icon-heart'} onClick={handleWishlistToggle}></i>
                    </span>
                )}
            </div>
        </>
    );
};

export default ProductWishlist;
